import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { IContactFormValues } from "../../Orchestrator/Types/Interface/ICustomerContact";

export async function postContactForm(
  payload: IContactFormValues
): Promise<IApiResponse<any>> {
  const ENDPOINTS = await getEndpoints();
  return await apiRequest<any>(ENDPOINTS.postContactForm, "POST", {
    body: JSON.stringify(payload),
  });
}
